/* eslint-disable */
import { Editor } from '@ckeditor/ckeditor5-core';
import DocumentSelection from '@ckeditor/ckeditor5-engine/src/model/documentselection';
import Writer from '@ckeditor/ckeditor5-engine/src/model/writer';
import { AxiosError, AxiosResponse } from 'axios';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ErrorInfo, PostSectionPss200 } from '../../../../../api/model';
import { usePostSectionPsinfo, usePostSectionPss } from '../../../../../api/sections/sections';
import { useDefaultOptions } from '../../../../../hooks/api';
import ConfirmModal from '../../../../modules/ConfirmModal';
import ErrorModal from '../../../../modules/ErrorModal';
import OkModal from '../../../../modules/OkModal';
import SpinnerModal from '../../../../modules/SpinnerModal';
import PsGetter from '../../../ps/details/PsGetter';
import { ElementDefinition } from '../dataTree/Definition';

interface Attribute {
  on: boolean;
  name: string;
  value: string;
  parentName: string;
}

interface Tag {
  name: string;
  definition: ElementDefinition;
  attributes: Attribute[];
}

interface Props {
  editor: Editor;
  psVersionId: string | undefined; // 選択されたPsVersionId
  productionId: number | undefined;
  // eslint-disable-next-line
  psDerivationId?: string | undefined; // 派生を選択する場合に指定
  level: string | undefined;
  zentekiPsNos: any; // ckeditorAdapter.state.zentekiPsNos
  setZentekiPsNos: (zentekiPsNos: any) => void; // ckeditorAdapter.state.zentekiPsNos更新用の関数
  runZentekiAttr: () => void; // ZENTEKI表示
}

function PsPage({
  editor,
  psVersionId,
  productionId,
  psDerivationId,
  level,
  zentekiPsNos,
  setZentekiPsNos,
  runZentekiAttr,
}: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const options = useDefaultOptions(language);

  // PS情報ダイアログで選択された派生
  const [selectedPsDerivationId, setSelectedPsDerivationId] = useState<number | undefined>(undefined);

  // 表示するPSバージョンID
  const [selectedPsVersionId, setSelectedPsVersionId] = useState<number | undefined>(undefined);

  // 入力用PS管理Noから取得されるPSバージョンID
  // const [inputPsVersionId, setInputPsVersionId] = useState<number | undefined>(-1);

  // デフォルト派生ID
  const [defaultPsDerivationId, setDefaultPsDerivationId] = useState<number | undefined>(undefined);

  // 入力PS管理No.
  const [inputPsNo, setInputPsNo] = useState<string>('');

  // 最新版を表示ボタンの文字色
  const [foreColor, setForeColor] = useState<string>('#9d9d9d');

  // PSのメッセージ
  const [psInfomation, setPsInfomation] = useState<string | undefined>('');

  const [psError, setPsError] = useState<Boolean | undefined>(false);

  // コピー終了
  const [endCopy, setEndCopy] = useState(false);

  // 表示したいバージョンID
  const dispPsVersionId = useMemo(() => {
    /*
    console.log('----------------------------------------------');
    console.log(`psVersionId : ${psVersionId}`);
    console.log(`selectedPsVersionId : ${selectedPsVersionId}`);
    console.log(`psDerivationId : ${psDerivationId}`);
    console.log(`selectedPsDerivationId : ${selectedPsDerivationId}`);
    // console.log(`inputPsVersionId : ${inputPsVersionId}`);
    console.log(`inputPsNo : ${inputPsNo}`);
    */

    // カーソルを移動させた場合、入力PS管理Noをクリアする
    if (psVersionId !== undefined && psVersionId !== '@@@' && psDerivationId !== undefined) {
      // if (inputPsVersionId === 0 || (inputPsVersionId !== 0 && selectedPsVersionId !== Number(psVersionId))) {
      // console.log('入力 クリア');
      setInputPsNo('');
      // setInputPsVersionId(0);
      // }
    }
    setForeColor('#9d9d9d');

    /*
    // 入力PS管理Noからデータ取得
    if (inputPsVersionId !== null && inputPsVersionId !== undefined && inputPsVersionId > 0) {
      console.log('入力 version');
      setSelectedPsDerivationId(undefined); // 入力PS管理Noの場合、派生IDをクリアする
      setDefaultPsDerivationId(undefined); // 入力PS管理Noの場合、派生IDをクリアする
      setSelectedPsVersionId(inputPsVersionId); // 画面を消す
      return inputPsVersionId;
    }
    */
    setPsInfomation('');
    setSelectedPsVersionId(undefined);

    // psDerivationId が変更されたら defaultPsDerivationId の値を変更
    setDefaultPsDerivationId(
      psDerivationId === undefined ? psDerivationId : psDerivationId === '@@@' ? -1 : Number(psDerivationId)
    );
    if (psDerivationId !== undefined) {
      // psDerivationId に値がある場合、 selectedPsDerivationId の値に psDerivationId をセットする(派生ラジオを変更しない時の値が取れないため)
      setSelectedPsDerivationId(psDerivationId === '@@@' ? -1 : Number(psDerivationId));
    }

    /*
    if (inputPsVersionId === 0) {
      setSelectedPsVersionId(undefined);
    }

    // 入力項目からデータを取得できない
    if (inputPsVersionId === null || inputPsVersionId === undefined) {
      setSelectedPsVersionId(undefined); // 画面を消す
      return inputPsVersionId;
    }
    */

    // 画面から派生を取得できない
    if (psVersionId === undefined || psVersionId === '@@@') {
      setSelectedPsVersionId(undefined);
    } else {
      // ここを入れると自動で表示するが、差替えなどが出来なくなる？
      setSelectedPsVersionId(Number(psVersionId));
    }
    return psVersionId === undefined ? psVersionId : psVersionId === '@@@' ? undefined : Number(psVersionId);
  }, [psVersionId, psDerivationId]);

  // コントロールの有効無効
  const controlEnb = useMemo(() => {
    return selectedPsVersionId !== null && selectedPsVersionId !== undefined && psError === false;
  }, [selectedPsVersionId, psError]);

  // 最新版を表示
  const controlNewEnb = useMemo(() => {
    return selectedPsVersionId !== null && selectedPsVersionId !== undefined && psError === false && inputPsNo === '';
  }, [selectedPsVersionId, psError, inputPsNo]);

  // #region 最新判定
  const { mutateAsync: psInfoAsync } = usePostSectionPsinfo<AxiosError<ErrorInfo>>(options);
  const getPsInfo = useCallback(
    async (psVersionId: number) => {
      await psInfoAsync(
        { data: { ps_no: undefined, ps_version_id: psVersionId } },
        {
          onSuccess: (response) => {
            if (response.data.latest_ps_version_id === null) {
              setForeColor('#9d9d9d');
            } else if (response.data.is_new === true) {
              setForeColor('#2e8b57');
            } else {
              setForeColor('#ff0000');
            }
            setPsInfomation(response.data.mesasge);
            setPsError(response.data.error_flg);
          },
        }
      );
    },
    [psInfoAsync, setForeColor, setPsInfomation]
  );
  // #endregion

  // #region 入力PSNoから最新版の情報を取得、もしくは最新版を表示から最新版の情報を取得
  const getPsVersionId = useCallback(
    async (psNo: string | undefined, psVId: number | undefined) => {
      return await psInfoAsync(
        { data: { ps_no: psNo, ps_version_id: psVId } },
        {
          onSuccess: (response) => {
            if (psVId === undefined) {
              console.log(response);
              setSelectedPsDerivationId(undefined); // 入力PS管理Noの場合、派生IDをクリアする
              setDefaultPsDerivationId(undefined); // 入力PS管理Noの場合、派生IDをクリアする
              if (response.data.latest_ps_version_id !== null) {
                setSelectedPsVersionId(response.data.latest_ps_version_id);
              } else {
                setSelectedPsVersionId(undefined);
                setForeColor('#9d9d9d');
              }
            } else {
              // 最新版表示の時はselectedPsVersionIdを更新することで画面を更新する
              setSelectedPsDerivationId(undefined); // 派生IDをクリアする
              setDefaultPsDerivationId(undefined); // 派生IDをクリアする
              setSelectedPsVersionId(response.data.latest_ps_version_id);
            }
            setPsInfomation(response.data.mesasge);
            setPsError(response.data.error_flg);
          },
        }
      );
    },
    [psInfoAsync, setSelectedPsVersionId, setPsInfomation]
  );
  // #endregion

  // #region PS差替え
  const [confirmPsReplace, setConfirmPsReplace] = useState(false); // 確認ダイアログ
  const [confirmPsInsert, setConfirmPsInsert] = useState(false); // 確認ダイアログ
  const [displayError, setDisplayError] = useState(false); // エラーダイアログ
  const [displayNotAction, setDisplayNotAction] = useState(0); // エラーダイアログ
  const [targetFrontValue, setTargetFrontValue] = useState(''); // 差替えターゲットの最初の文字
  const [targetRearValue, setTargetRearValue] = useState(''); // 差替えターゲットの最初の文字

  const {
    mutateAsync: pssAsync,
    isLoading: isPssLoading,
    isError: isPssError,
    error: pssError,
  } = usePostSectionPss<AxiosError<ErrorInfo>>(options);

  useEffect(() => {
    setDisplayError(isPssError);
  }, [isPssError]);

  // 自身がPSの一部かどうかチェックする関数
  const searchPsDiv = (element: any): any => {
    console.log(element);
    if (element.name === 'htmlDiv') {
      const attr = element.getAttribute('htmlDivAttributes');
      console.log(attr);
      if (attr !== undefined) {
        if (attr.attributes !== undefined) {
          if (
            attr.attributes['ps_no'] !== undefined &&
            attr.attributes['ps_version_id'] !== undefined &&
            attr.attributes['ps_derivation_id'] !== undefined
          ) {
            if (
              attr.attributes['ps_no'] !== '' &&
              attr.attributes['ps_version_id'] !== '' &&
              attr.attributes['ps_derivation_id'] !== ''
            ) {
              return element;
            }
          }
        }
      }
    }
    if (!element.parent) {
      return undefined;
    }
    return searchPsDiv(element.parent);
  };

  /** PS差替え前のターゲット情報取得 */
  const getTargetInfo = useCallback(() => {
    // 現在のカーソル
    const selection: DocumentSelection = editor.model.document.selection;

    // 現在選択中のElementを取得
    const elements = Array.from(selection.getSelectedBlocks());
    if (elements[0]) {
      const element = elements[0];

      // 自身がPSの要素か確認し、PSの要素ならDIV要素を返す
      const psElement = searchPsDiv(element);
      if (psElement) {
        // 派生IDを取得
        const attr: any = psElement.getAttribute('htmlDivAttributes');
        const id = attr.attributes['ps_derivation_id'];

        // 派生IDのPSのtextから前後10文字を変数にセットする
        document.querySelectorAll(`[ps_derivation_id='${id}']`).forEach((element: Element) => {
          const valueStr: string = element.textContent ?? '';
          setTargetFrontValue(valueStr.slice(0, 15));
          setTargetRearValue(valueStr.slice(-15));
        });
      }
    }
  }, [searchPsDiv]);

  /** PSID差替え */
  const ReplaceId = useCallback(() => {
    void pssAsync(
      {
        data: { production_id: productionId, ps_derivation_id: selectedPsDerivationId, level: level },
      },
      {
        onSuccess: (response) => {
          if (response.status === 200) {
            if (response.data.ps_no !== undefined) {
              /*
              【実行条件】
              カーソルがPSエレメント内である
              PS管理Noが一致している

              【属性の操作】
              fsr_id属性があれば削除
              title属性があれば削除
              confirmed属性値を0
              ps_no属性値を更新
              ps_version_id属性値を更新
              ps_derivation_id属性値を更新
              */

              editor.model.change((writer: Writer) => {
                // 現在のカーソル
                const selection: DocumentSelection = editor.model.document.selection;

                // 現在選択中のElementを取得
                const elements = Array.from(selection.getSelectedBlocks());
                if (elements[0]) {
                  const element = elements[0];

                  // 自身がPSの要素か確認し、PSの要素ならDIV要素を返す
                  const psElement = searchPsDiv(element);
                  if (psElement) {
                    let attributes = psElement.getAttribute('htmlDivAttributes') as any;

                    if (attributes) {
                      const parsed = JSON.parse(JSON.stringify(attributes));

                      if ('ps_no' in parsed.attributes) {
                        if (parsed.attributes.ps_no === response.data.ps_no) {
                          // レックスペックid属性は使っていないのであれば削除する。
                          if ('fsr_id' in parsed.attributes) {
                            delete parsed.attributes.fsr_id;
                          }

                          // タイトル属性も一度削除する
                          if ('title' in parsed.attributes) {
                            delete parsed.attributes.title;
                          }

                          // テキスト確定を未確定にする
                          if ('confirmed' in parsed.attributes) {
                            parsed.attributes.confirmed = 0;
                          }

                          // id差替え
                          parsed.attributes.ps_no = response.data.ps_no;
                          parsed.attributes.ps_version_id = response.data.ps_version_id;
                          parsed.attributes.ps_derivation_id = response.data.ps_derivation_id;

                          writer.setAttribute(
                            'htmlDivAttributes',
                            parsed as Record<string, string | number | boolean>,
                            psElement
                          );
                        } else {
                          // PSNoが異なるのでidの差替えはできない
                          setDisplayNotAction(5);
                        }
                      }
                    } else {
                      // 属性値が取得できない
                      setDisplayNotAction(4);
                    }
                  } else {
                    setDisplayNotAction(3);
                  }
                }
              });

              // Zenteki表示処理
              void setZenteki(response, false);
            }
          }
        },
      }
    );
  }, [selectedPsDerivationId, productionId, pssAsync, editor, searchPsDiv, level]);

  /** PS差替え */
  const getPS = useCallback(
    (insert: boolean, copy: boolean) => {
      void pssAsync(
        {
          data: { production_id: productionId, ps_derivation_id: selectedPsDerivationId, level: level },
        },
        {
          onSuccess: (response) => {
            if (response.status === 200) {
              if (response.data.content_xml !== undefined) {
                const pasteXml = response.data.content_xml;

                if (copy) {
                  // クリップボードへ
                  void global.navigator.clipboard.writeText(pasteXml);
                  setEndCopy(true);
                } else {
                  // 差替え
                  editor.model.change((writer) => {
                    // 現在のカーソル
                    const selection: DocumentSelection = editor.model.document.selection;

                    // 現在選択中のElementを取得
                    const elements = Array.from(selection.getSelectedBlocks());
                    if (elements[0]) {
                      const element = elements[0];

                      // 自身がPSの要素か確認し、PSの要素ならDIV要素を返す
                      const psElement = searchPsDiv(element);
                      if (psElement) {
                        // カーソルを該当PSDIVの後ろに持っていく
                        writer.setSelection(psElement, 'after');
                        // HTMLを入れ込む
                        const viewFragment = editor.data.processor.toView(pasteXml);
                        const modelFragment = editor.data.toModel(viewFragment);
                        const modelRange = editor.model.insertContent(modelFragment);
                        // 追加したセクションにカーソルを持っていく
                        writer.setSelection(modelRange, 'in');
                        // 追加した現在選択中のElementを取得
                        const elementsAdd = Array.from(selection.getSelectedBlocks());
                        const elementAdd = elementsAdd[0];
                        // 追加したものがPSの要素か確認し、PSの要素ならDIV要素を返す（PSを追加しているので間違いなくPSのはず）
                        const psElementAdd = searchPsDiv(elementAdd);

                        // 削除処理
                        if (!insert) {
                          // カーソルを該当PSに持っていく
                          writer.setSelection(psElement, 'on');
                          const deleteselection = editor.model.document.selection;
                          // 削除
                          editor.model.deleteContent(deleteselection, { doNotAutoparagraph: true }); // optionとして削除後に勝手にp要素を作成させないを設定
                        }

                        if (psElementAdd) {
                          // カーソルを追加PSDIV内に持っていく
                          writer.setSelection(psElementAdd, 'in');
                        }
                      } else {
                        if (!insert) {
                          setDisplayNotAction(1);
                        } else {
                          setDisplayNotAction(2);
                        }
                      }
                    }
                  });
                  // Zenteki表示処理
                  void setZenteki(response, insert);
                }
              }
            }
          },
        }
      );
    },
    [selectedPsDerivationId, productionId, pssAsync, editor, searchPsDiv, level]
  );

  /**
   * zenteki情報更新
   * @param response
   */
  const setZenteki = (response: AxiosResponse<PostSectionPss200, any>, insert: boolean) => {
    let newArray: string[] = [];
    if (zentekiPsNos) {
      newArray = [...zentekiPsNos];
    }

    if (!insert) {
      // 差替え・ID差替えの場合、該当ps_noを削除
      newArray = newArray.filter((item, i) => item !== response.data.ps_no);
    }

    // zentekiなら取得したps_noを配列に追加
    if (response.data.is_zenteki) {
      newArray.push(String(response.data.ps_no));
    }

    setZentekiPsNos(newArray); // ckeditorAdapter.state.zentekiPsNosの更新
    runZentekiAttr(); // Zenteki表示関数実行
  };
  // #endregion

  /**
   * dispPsVersionIdが変化したら実行
   */
  useEffect(() => {
    if (dispPsVersionId !== undefined) {
      console.log(`useEffect => ${dispPsVersionId}`);
      void getPsInfo(Number(dispPsVersionId));
    }
  }, [dispPsVersionId]);

  return (
    <div>
      <div className="master-navi">
        <ul>
          <li className="labip2">
            <div style={{ width: '300px' }}>
              <label htmlFor="input_psno">{t('PS管理No.')}</label>
              <input
                type="text"
                id="input_psno"
                value={inputPsNo}
                onChange={(e) => {
                  setInputPsNo(e.target.value);
                  if (e.target.value === '') {
                    /** クリア */
                    // setInputPsVersionId(0);
                    setSelectedPsDerivationId(
                      psDerivationId === undefined
                        ? psDerivationId
                        : psDerivationId === '@@@'
                        ? undefined
                        : Number(psDerivationId)
                    ); // 原稿編集が選択中の派生ID
                    setDefaultPsDerivationId(
                      psDerivationId === undefined
                        ? psDerivationId
                        : psDerivationId === '@@@'
                        ? undefined
                        : Number(psDerivationId)
                    ); // 原稿編集が選択中の派生ID
                    setForeColor('#9d9d9d');
                  }
                }}
              />
            </div>
          </li>
          {/* ボタンを生かす */}
          <li
            className=""
            onClick={async () => {
              if (inputPsNo !== '') {
                // PS管理Noの入力があった場合、バージョンIDを取得
                const vid = await getPsVersionId(inputPsNo, undefined);
                setForeColor('#84b197');

                /*
                if (vid.data.latest_ps_version_id !== undefined || vid.data.latest_ps_version_id !== null) {
                  // await getPsInfo(Number(vid.data.latest_ps_version_id));
                  // setSelectedPsVersionId(vid.data.latest_ps_version_id);
                }
                */
              } else {
                /*
                // PS情報表示
                setSelectedPsVersionId(dispPsVersionId);
                if (dispPsVersionId !== undefined) {
                  await getPsInfo(Number(dispPsVersionId));
                }
                */
              }
            }}
            style={{ paddingTop: '3px' }}
          >
            <span>
              <i className="fa-solid fa-eye" />
              {t('PS情報表示')}
            </span>
          </li>
          <li onClick={() => controlEnb && ReplaceId()} style={{ paddingTop: '3px' }}>
            <span className={controlEnb ? 'span-fa-enable' : 'span-fa-disable'}>
              <i className="fa-solid fa-exchange-alt" />
              {t('ID差替え ')}
            </span>
          </li>
          <li
            onClick={() => {
              if (controlEnb) {
                // カーソルがあるPSの前後10文字をセット
                void getTargetInfo();

                // 確認ダイアログを表示
                setConfirmPsReplace(true);
              }
            }}
            style={{ paddingTop: '3px' }}
          >
            <span className={controlEnb ? 'span-fa-enable' : 'span-fa-disable'}>
              <i className="fa-solid fa-retweet" />
              {t('PS入替え')}
            </span>
          </li>
          <li onClick={() => controlEnb && setConfirmPsInsert(true)} style={{ paddingTop: '3px' }}>
            <span className={controlEnb ? 'span-fa-enable' : 'span-fa-disable'}>
              <i className="fa-solid fa-plus-square" />
              {t('PS挿入')}
            </span>
          </li>
          <li style={{ paddingTop: '3px' }}>
            <Link to={`/${language}/ps/view/${Number(selectedPsVersionId)}`} target="_blank">
              <span className={'span-fa-enable'}>
                <i className="fa-solid fa-book" />
                {t('別タブで表示')}
              </span>
            </Link>
          </li>
        </ul>
        <ul>
          <li>
            <p style={{ color: 'red' }}>{psInfomation}</p>
          </li>
          <li
            className=""
            onClick={() => {
              if (controlNewEnb) {
                //if (selectedPsVersionId && selectedPsVersionId !== undefined) {
                void getPsVersionId(undefined, dispPsVersionId);
                // setSelectedPsVersionId(dispPsVersionId);
                setForeColor('#84b197');
              }
            }}
            style={{ paddingTop: '3px', position: 'absolute', left: '315px' }}
          >
            <span style={{ color: foreColor }}>
              <i className="fa-solid fa-redo" style={{ color: foreColor }} />
              {t('最新版を表示')}
            </span>
          </li>
        </ul>
      </div>
      {/* ボタンを生かすには、dispPsVersionIdをselectedPsVersionIdとする */}
      {/* ボタンを生さない場合には、selectedPsVersionIdをdispPsVersionIdとする */}
      {selectedPsVersionId && selectedPsVersionId !== undefined && (
        <PsGetter
          mode="View"
          psInfoTabMode
          psVersionId={selectedPsVersionId}
          setSelectedDerivationId={(selectedDerivationId: number | undefined) => {
            setSelectedPsDerivationId(selectedDerivationId);
          }}
          selectedDerivationId={defaultPsDerivationId}
        />
      )}
      {((selectedPsVersionId === undefined && inputPsNo !== '') || psVersionId === '@@@') && (
        <div className="browsefr">
          <div>
            <p style={{ color: '#ff0000' }}>
              <strong>{t('No results found.')}</strong>
            </p>
          </div>
        </div>
      )}
      {psVersionId === undefined && inputPsNo === '' && (
        <div className="browsefr">
          <div>
            <p style={{ color: '#ff0000' }}>
              <strong>{t('There is no PS at the cursor position.')}</strong>
            </p>
          </div>
        </div>
      )}

      {/* スピナーモーダル */}
      {isPssLoading && <SpinnerModal />}
      {/* 出力エラー */}
      {displayError && <ErrorModal error={pssError} onClickOk={() => setDisplayError(false)} />}
      {/* PS差替え確認 */}
      {confirmPsReplace && (
        <ConfirmModal
          onClickCancel={() => setConfirmPsReplace(false)}
          onClickOk={async () => {
            setConfirmPsReplace(false);
            void getPS(false, false);
          }}
        >
          {t('カーソルにある原稿データを差し替えますか？コメントは消えます。「')}
          {targetFrontValue}
          {t('」から「')}
          {targetRearValue}
          {t('」までが置き換わります。')}
        </ConfirmModal>
      )}
      {/* PS挿入 */}
      {confirmPsInsert && (
        <ConfirmModal
          onClickCancel={() => setConfirmPsInsert(false)}
          onClickOk={async () => {
            setConfirmPsInsert(false);
            void getPS(true, false);
          }}
        >
          {t('PSを挿入しますか？')}
        </ConfirmModal>
      )}
      {/* コピー終了 */}
      {endCopy && <OkModal onClickOk={() => setEndCopy(false)}>{t('クリップボードにコピーしました。')}</OkModal>}
      {/* 処理できない */}
      {displayNotAction > 0 && (
        <OkModal onClickOk={() => setDisplayNotAction(0)}>
          {displayNotAction === 1 && t('カーソル部にPSがないので差替えできません。')}
          {displayNotAction === 2 && t('カーソル部にPSがないので挿入できません。')}
          {displayNotAction === 3 && t('カーソル部にPSがないのでID差替えができません。')}
          {displayNotAction === 4 && t('カーソル部のPS属性が存在しません。')}
          {displayNotAction === 5 && t('PS管理No.が異なるのでID差替えができません。')}
        </OkModal>
      )}
    </div>
  );
}
export default PsPage;
